// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { takeLatest, put, all, call } from 'redux-saga/effects';
import VerificationDetailsActionTypes from './verification-details.types';
import {
	verificationDetailsAdd,
	updateVerificationDetails,
	fetchVerificationDetails,
	deleteVerificationDetails,
} from './verification-details.service';
import {
	addBusinessVerificationSuccess,
	addBusinessVerificationFailure,
	addBusinessVerificationResponseChanged,
	updateBusinessVerificationSuccess,
	updateBusinessVerificationFailure,
	updateBusinessVerificationResponseChanged,
	fetchBusinessVerificationSuccess,
	fetchBusinessVerificationFailure,
	fetchBusinessVerificationResponseChanged,
	deleteBusinessVerificationResponseChanged,
	deleteBusinessVerificationSuccess,
	deleteBusinessVerificationFailure,
} from './verification-details.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD BUSINESS VERIFICATION  ******************** */
export function* businessVerificationAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, verificationListArr } = payload;
		const key = 'BusinessVerificationKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			VerificationListArr: verificationListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(verificationDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessVerificationFailure(responseData.data));
		} else {
			yield put(addBusinessVerificationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessVerificationFailure(error));
	}
}

export function* resetAddBusinessVerificationResponse() {
	yield put(addBusinessVerificationResponseChanged());
}

export function* onAddBusinessVerificationDetails() {
	yield takeLatest(
		VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_START,
		businessVerificationAdd,
	);
}

export function* onAddBusinessVerificationResponseReset() {
	yield takeLatest(
		VerificationDetailsActionTypes.ADD_BUSINESS_VERIFICATION_RESPONSE_RESET,
		resetAddBusinessVerificationResponse,
	);
}
/** *********************  END ADD BUSINESS VERIFICATION ******************** */

/** *********************  START UPDATE BUSINESS VERIFICATION  ******************** */
export function* businessVerificationUpdate({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, verificationListArr } = payload;
		const key = 'UpdateBusinessVerificationKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			VerificationListArr: verificationListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updateVerificationDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessVerificationFailure(responseData.data));
		} else {
			yield put(updateBusinessVerificationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessVerificationFailure(error));
	}
}

export function* resetUpdateBusinessVerificationResponse() {
	yield put(updateBusinessVerificationResponseChanged());
}

export function* onUpdateBusinessVerificationDetails() {
	yield takeLatest(
		VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_START,
		businessVerificationUpdate,
	);
}

export function* onUpdateBusinessVerificationResponseReset() {
	yield takeLatest(
		VerificationDetailsActionTypes.UPDATE_BUSINESS_VERIFICATION_RESPONSE_RESET,
		resetUpdateBusinessVerificationResponse,
	);
}
/** *********************  END UPDATE BUSINESS VERIFICATION ******************** */

/** *********************  START FETCH BUSINESS VERIFICATION  ******************** */
export function* businessVerificationFetch({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName } = payload;
		const key = 'GetBusinessVerifyKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchVerificationDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessVerificationFailure(responseData.data));
		} else {
			yield put(fetchBusinessVerificationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessVerificationFailure(error));
	}
}

export function* resetFetchBusinessVerificationResponse() {
	yield put(fetchBusinessVerificationResponseChanged());
}

export function* onFetchBusinessVerificationDetails() {
	yield takeLatest(
		VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_START,
		businessVerificationFetch,
	);
}

export function* onFetchBusinessVerificationResponseReset() {
	yield takeLatest(
		VerificationDetailsActionTypes.FETCH_BUSINESS_VERIFICATION_RESPONSE_RESET,
		resetFetchBusinessVerificationResponse,
	);
}
/** *********************  END FETCH BUSINESS VERIFICATION ******************** */

export function* businessVerificationDelete({ payload }: any) {
	try {
		const { businessVerificationID, companyID, databaseName } = payload;
		const key = 'DeleteBusinessVerificationDetailsKey';
		const jsonData = {
			BusinessVerificationID: businessVerificationID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(deleteVerificationDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBusinessVerificationFailure(responseData.data));
		} else {
			yield put(deleteBusinessVerificationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBusinessVerificationFailure(error));
	}
}

export function* resetDeleteBusinessVerificationResponse() {
	yield put(deleteBusinessVerificationResponseChanged());
}

export function* onDeleteBusinessVerificationDetails() {
	yield takeLatest(
		VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_START,
		businessVerificationDelete,
	);
}

export function* onDeleteBusinessVerificationResponseReset() {
	yield takeLatest(
		VerificationDetailsActionTypes.DELETE_BUSINESS_VERIFICATION_RESPONSE_RESET,
		resetDeleteBusinessVerificationResponse,
	);
}

export function* verificationDetailsSaga() {
	yield all([
		call(onAddBusinessVerificationDetails),
		call(onAddBusinessVerificationResponseReset),
		call(onUpdateBusinessVerificationDetails),
		call(onUpdateBusinessVerificationResponseReset),
		call(onFetchBusinessVerificationDetails),
		call(onFetchBusinessVerificationResponseReset),
		call(onDeleteBusinessVerificationDetails),
		call(onDeleteBusinessVerificationResponseReset),
	]);
}
